<template>
  <div class="img-wrapper">
    <img :src="src" @load="onLoad" class="img" v-show="show">
    <img class="img" src="../../assets/images/default-bg.png" v-show="!show">
  </div>
</template>

<script>
export default {
  props: ['src'],
  data() {
    return {
      show: false
    };
  },
  methods: {
    onLoad() {
      this.show = true;
    }
  }
};
</script>

<style scoped>
.img-wrapper {
  width: 100%;
  height: 100%;
}
.img {
  width: 100%;
  height: 100%;
}
</style>
